// // // // // // //  OLD VERSION  // // // // // // //

// // processGeoData.js
// import { isEmptyArray } from "formik";
// import { useEffect } from "react";
// import { toast } from "react-toastify";

// const useProcessGeoData = (polyData, isLoaded, setPolygonPaths) => {
//   useEffect(() => {
//     if (isLoaded) {
//       if (isEmptyArray(polyData)) {
//         // toast.error("data not available");
//       }

//       if (polyData[0]?.boundaries?.type === "FeatureCollection") {
//         const featureGeoJson = polyData[0]?.boundaries?.features.map(
//           (feature) => {
//             let featureCoordinates = [];
//             if (feature.geometry?.type === "MultiPolygon") {
//               featureCoordinates = feature.geometry?.coordinates.flat(2);
//             } else if (feature.geometry?.type === "Polygon") {
//               featureCoordinates = feature.geometry?.coordinates[0];
//             }

//             return {
//               // constituencyId: polyData[0]?._id || "",
//               coordinate: featureCoordinates
//                 ? featureCoordinates.map((coord) => ({
//                     lat: coord[1],
//                     lng: coord[0]
//                   }))
//                 : [],
//               // name: feature?.properties?.WARD_NAME || "",
//               // state: polyData[0]?.state,
//               // district: polyData[0]?.name
//             };
//           }
//         );
//         setPolygonPaths(featureGeoJson);
//       } else {
//         const geoJSON = (Array.isArray(polyData) ? polyData : []).map(
//           (item) => {
//             let coordinates = [];
//             const boundaries = item?.boundaries;
//             if (boundaries?.type === "Polygon") {
//               coordinates = boundaries?.coordinates[0];
//             } else if (boundaries?.type === "MultiPolygon") {
//               coordinates = boundaries?.coordinates.flat(2);
//             } else if (boundaries?.type === "FeatureCollection") {
//               coordinates = boundaries?.features.flatMap((feature) => {
//                 if (feature.geometry?.type === "MultiPolygon") {
//                   return feature.geometry?.coordinates.flat(2);
//                 } else if (feature.geometry?.type === "Polygon") {
//                   return feature.geometry?.coordinates[0];
//                 }
//                 return [];
//               });
//             }

//             return {
//               // constituencyId: item?._id || "",
//               coordinate: coordinates
//                 ? coordinates.map((coord) => ({
//                     lat: coord[1],
//                     lng: coord[0]
//                   }))
//                 : []
//               // name: item?.name,
//               // state: item?.state,
//               // district: item?.district
//             };
//           }
//         );
//         setPolygonPaths(geoJSON);
//       }
//     }
//   }, [polyData, isLoaded]);
// };

// export default useProcessGeoData;


import { useEffect } from "react";

const useProcessGeoData = (polyData, isLoaded, setPolygonPaths, tab = "") => {
  useEffect(() => {
    if (!isLoaded) return;

    const data = Array.isArray(polyData) ? polyData : [];
    const formattedPolygons = [];

    if (polyData[0]?.boundaries?.type === "FeatureCollection") {
      const featureGeoJson = polyData[0]?.boundaries?.features.map((feature) => {
        let featureCoordinates = [];

        if (feature.geometry?.type === "MultiPolygon") {
          featureCoordinates = feature.geometry?.coordinates.flat(2);
        } else if (feature.geometry?.type === "Polygon") {
          featureCoordinates = feature.geometry?.coordinates[0];
        }

        return {
          constituencyId: polyData[0]?._id || "",
          coordinate: featureCoordinates.map((coord) => ({
            lat: coord[1],
            lng: coord[0],
          })),
          name: polyData[0]?.name || "",
          state: polyData[0]?.state,
          district: polyData[0]?.district,
        };
      });

      setPolygonPaths([[...featureGeoJson]]);
    } else {
      data.forEach((item) => {
        const boundaries = item?.boundaries;
        const baseData = {
          constituencyId: item?._id || "",
          name: item?.name,
          state: item?.state,
          district: item?.district,
        };

        if (!boundaries) return;

        if (boundaries.type === "Polygon") {
          formattedPolygons.push([
            {
              ...baseData,
              coordinate: (boundaries.coordinates?.[0] || []).map((coord) => ({
                lat: coord[1],
                lng: coord[0],
              })),
            },
          ]);
        } else if (boundaries.type === "MultiPolygon") {
          const polygonGroup = [];
          (boundaries.coordinates || []).forEach((polygon) => {
            (polygon || []).forEach((ring) => {
              polygonGroup.push({
                ...baseData,
                coordinate: ring.map((coord) => ({
                  lat: coord[1],
                  lng: coord[0],
                })),
              });
            });
          });
          formattedPolygons.push(polygonGroup);
        } else if (boundaries.type === "FeatureCollection") {
          const featureGroup = [];
          (boundaries.features || []).forEach((feature) => {
            const geom = feature.geometry;
            if (!geom) return;

            if (geom.type === "Polygon") {
              (geom.coordinates || []).forEach((ring) => {
                featureGroup.push({
                  ...baseData,
                  coordinate: ring.map((coord) => ({
                    lat: coord[1],
                    lng: coord[0],
                  })),
                });
              });
            } else if (geom.type === "MultiPolygon") {
              (geom.coordinates || []).forEach((polygon) => {
                (polygon || []).forEach((ring) => {
                  featureGroup.push({
                    ...baseData,
                    coordinate: ring.map((coord) => ({
                      lat: coord[1],
                      lng: coord[0],
                    })),
                  });
                });
              });
            }
          });
          formattedPolygons.push(featureGroup);
        }
      }); 

      setPolygonPaths(formattedPolygons[0]);
    }
  }, [polyData, isLoaded, setPolygonPaths, tab]);
};

export default useProcessGeoData;

